import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons'; 
import { useTranslation } from 'react-i18next'; // Importer useTranslation
import "./portfolio.scss";

// Définition de la fonction Portfolio qui gère la page du portfolio.
function Portfolio() { 
  const { t } = useTranslation();
  const [filter, setFilter] = useState("");
  
  const [projects] = useState([
    

     {
      id: 14,
      name: t("projects.tempCleaner.name"),
      technology: "Python, Planificateur de tâches",
      image: "images/Fichiers_Temporaires.png",
      link: "https://github.com/akamidev/python",
      description: t("projects.tempCleaner.description"),
    },

     {
      id: 9,
      name: t("projects.kasa.name"),
      technology: "JS, React, SCSS, API, Figma",
      image: "images/projet-Kasa.jpg",
      link: "https://github.com/akamidev/ProcessMoniteur",
      description: t("projects.kasa.description"),
    },
     {
      id: 17,
      name: t("projects.processMonitor.name"),
      technology: "Java, Maven, OSHI, JavaMail",
      image: "images/MonitorProcess.png",
      link: "https://github.com/akamidev/ProcessMoniteur",
      description: t("projects.processMonitor.description"),
    },
    

  {
      id: 5,
      name: t("projects.rentaRoom.name"),
      technology: "Symfony, Twig, Bootstrap",
      image: "images/rentaroom.png",
      link: "https://github.com/EmmanuelMendanha/RentaRoom",
      description: t("projects.rentaRoom.description"),
    },
     {
      id: 10,
      name: t("projects.luxanimalis.name"),
      technology: "WordPress, WooCommerce, SEO, HTML",
      image: "images/luxanimalis.png",
      link: "https://luxanimalis.com",
      description: t("projects.luxanimalis.description"),
    },
     {
      id: 4,
      name: t("projects.portfolio.name"),
      technology: "HTML, Sass, ReactJs, JavaScript, NodeJs",
      image: "images/PORTFOLIO-FIGMA.png",
      link: "https://github.com/akamidev/PORTFOLIO-FIGMA",
      description: t("projects.portfolio.description"),
    },
   
    {
      id: 3,
      name: t("projects.apiCinema.name"),
      technology: "PHP, MySQL",
      image: "images/ProjetPHP.png",
      link: "https://github.com/akamidev/Projet-Cin-ma-D-tail-Film-et-Liste-Membres",
      description: t("projects.apiCinema.description"),
    },

   
    
    {
      id: 6,
      name: t("projects.countrys.name"),
      technology: "HTML, Sass, ReactJs, JavaScript, API",
      image: "images/Countrys.png",
      link: "https://github.com/akamidev/COUNTRY",
      description: t("projects.countrys.description"),
    },
     {
      id: 2,
      name: t("projects.lapcom.name"),
      technology: "Symfony, MySQL",
      image: "images/Projetsymfony.png",
      link: "https://github.com/akamidev/LAPCOM",
      description: t("projects.lapcom.description"),
    },

    {
      id: 7,
      name: t("projects.pokedex.name"),
      technology: "HTML, ReactJs, JavaScript, Sass",
      image: "images/Pokedex.png",
      link: "https://github.com/akamidev/Pokedex",
      description: t("projects.pokedex.description"),
    },

   
    {
      id: 8,
      name: t("projects.siteWeb.name"),
      technology: 'HTML, CSS, JavaScript',
      image: "images/Siteweb1.png",
      link: "https://github.com/akamidev/SITEWEB_INTERACTIF",
      description: t("projects.siteWeb.description"),
    },

    {
      id: 11,
      name: t("projects.invoice.name"),
      technology: "HTML, CSS, JavaScript",
      image: "images/Factures.png",
      link: "https://github.com/akamidev/PROJET_FACTURE",
      description: t("projects.invoice.description"),
    },
   
   
    {
      id: 12,
      name: t("projects.dynamicSite.name"),
      technology: "PHP, MySQL",
      image: "images/PHP_Ecomerce.png",
      link: "https://github.com/akamidev/Projet-Site-Dynamique-PHP-Sans-BDD",
      description: t("projects.dynamicSite.description"),
    },
   
    {
      id: 13,
      name: t("projects.diskController.name"),
      technology: "Python, SMTP",
      image: "images/surveille-disque.png",
      link: "https://github.com/akamidev/surveillance_disque",
      description: t("projects.diskController.description"),
    },
   
    {
      id: 15,
      name: t("projects.cashChanger.name"),
      technology: "Python, API",
      image: "images/Convertisseur_monnaie.png",
      link: "https://github.com/akamidev/Convertisseur-de-Monnaies",
      description: t("projects.cashChanger.description"),
    },
    {
      id: 16,
      name: t("projects.workCycle.name"),
      technology: "Python, Tkinter",
      image: "images/Promodo.png",
      link: "https://github.com/akamidev/Planificateur-de-Pomodoro-en-Python",
      description: t("projects.workCycle.description"),
    },
    
     {
      id: 1,
      name: t("projects.uiux.name"),
      technology: "Figma",
      image: "images/TP-UI-UX.png",
      link: "https://github.com/akamidev/G-te-Les-Avineaux/tree/main?tab=readme-ov-file",
      description: t("projects.uiux.description"),
    },
   
    
  ]);

  const filteredProjects = projects.filter((project) =>
    project.name.toLowerCase().includes(filter.toLowerCase()) ||
    project.technology.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div id="portfolio" style={{ minHeight: '80vh', width: '90%', overflow: 'hidden' }}>
    <video
      autoPlay
      loop
      muted
      style={{
        position: 'fixed', // Fixe la position de la vidéo pour qu'elle reste en place lors du défilement
        top: '0',
        left: '0',
        width: '100vw', // Utilise 100vw pour couvrir toute la largeur de la fenêtre
        height: '100vh', // Utilise 100vh pour couvrir toute la hauteur de la fenêtre
        objectFit: 'cover',
        zIndex: '-1',
        pointerEvents: 'none', // Assure que la vidéo ne bloque pas les interactions
      }}
    >
        <source src="/images/videos/3129977-uhd_3840_2160_30fps.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la lecture vidéo.
      </video>
  <div className="portfolio-wrapper">
    <div className="portfolio-content">
    <h1 className="sub-title">{t('portfolioTitle')}</h1> {/* Traduction du titre principal */}
    <input
      type="text"
      placeholder={t('filterPlaceholder')} // Traduction du placeholder de l'input
      onChange={(e) => setFilter(e.target.value)}
    /> 
    <div className="work-list">
      {filteredProjects.map((project) => (
        <div className="work" key={project.id}>  
          <img src={project.image} alt={t(project.name)} /> {/* Traduction de l'attribut alt */}
          <div className="layer">
            <h1 className="attractive-heading">{t(project.name)}</h1> {/* Traduction du nom du projet */}
            <h2>{t(project.description)}</h2> {/* Traduction de la description du projet */}
            <hr className="separator" />
            <h3>{t(project.technology)}</h3> {/* Traduction des technologies utilisées */}
            <a href={project.link} className="link-button" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGithub} />
            </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
  );
}

export default Portfolio;
